module.exports = __webpack_public_path__ + "static/media/cricket.e8688a06.svg";